import { publicApi } from './http'

const responses = new Map()
const pending = new Map()

// Anonymous catalog/SEO reads only; private data and mutations never enter this cache.
export function getPublicData (path, params = {}, ttl = 10000) {
  const key = JSON.stringify([path, Object.keys(params).sort().map(name => [name, params[name]])])
  const cached = responses.get(key)
  if (cached && cached.expires > Date.now()) return Promise.resolve(cached.response)
  if (pending.has(key)) return pending.get(key)
  const request = (Object.keys(params).length ? publicApi.get(path, { params }) : publicApi.get(path))
    .then(response => {
      if (responses.size >= 100) responses.delete(responses.keys().next().value)
      responses.set(key, { response, expires: Date.now() + ttl })
      return response
    })
    .finally(() => pending.delete(key))
  pending.set(key, request)
  return request
}
